import $ from 'jquery';

function OccoApi() {
  // organisationId is optional
  this.robotListRetrieve = function (organisationId, callback) {
    const body = {};
    if (organisationId) {
      body.organisation_id = organisationId;
    }
    const methodPath = '/occo-owner/robot/list/retrieve';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
  this.stockImageListRetrieve = function (eventId, callback) {
    const body = {};
    if (eventId) {
      body.event_id = eventId;
    }
    const methodPath = '/occo-owner/stock-image/list/retrieve';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.organisationListRetrieve = function (callback) {
    const body = {};
    const methodPath = '/occo-owner/organisation/list/retrieve';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  /*
   * key_type possible values
   *   - event_owner_api_key (keyValue type string : eventOwnerApiKey)
   *   - event_public_api_key (keyValue type string : eventPublicApiKey)
   *   - event_private_api_key (keyValue type string : eventPrivateApiKey)
   *   - attendee_uid (keyValue type string : attendeeUid)
   *   - attendee_and_org_uids (keyValue type json obj e.g. {"attendee_uid" : "value1", "organisation_uid" : "value2"})
   */
  this.eventListRetrieve = function (keyType, keyValue, callback) {
    const body = {};
    body.max_size = 5000;
    body.page_number = 1;
    const hasApiKey = keyType == null;
    if (!hasApiKey) {
      body.key_type = keyType;
      body.key_value = keyValue;
    }
    const showApiErrors = keyType == 'event_owner_api_key';
    const methodPath = hasApiKey ? '/occo-owner/event/list/retrieve' : '/event/list/retrieve';
    _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  this.pptDelete = function (id, callback) {
    const body = {};
    body.id = id;
    const methodPath = '/occo-owner/ppt/delete';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  // organisationId is optional
  this.pptListRetrieve = function (organisationId, isWatermarkTemplate, callback) {
    const body = {};
    if (organisationId) {
      body.organisation_id = organisationId;
    }
    if (isWatermarkTemplate) {
      body.is_watermark = isWatermarkTemplate;
    }
    const methodPath = '/occo-owner/ppt/list/retrieve';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.customPhotoTmpUploadAccessRetrieve = function (event_name, file_name, keep_origin_name, attendeeUid, callback) {
    const body = {};
    body.event_name = event_name;
    body.file_name = file_name;
    body.keep_origin_name = keep_origin_name;
    body.attendee_uid = attendeeUid;
    const methodPath = '/event/tmp-photo-upload-access/retrieve';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.miniAlbumcreateCustomPhoto = function (eventName, fullPath, attendeeUid, callback) {
    const body = {};
    body.event_name = eventName;
    body.full_path = fullPath;
    body.attendee_uid = attendeeUid;
    const methodPath = '/event/create-attendee-custom-photo/async';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
  this.activityCreateByRobotId = function (robotId, photoId, activityName, activityType, attUid, callback) {
    const body = {};
    body.robot_id = robotId;
    body.photo_id = photoId;
    body.activity_name = activityName;
    body.activity_type = activityType;
    body.attUid = attUid;
    const methodPath = '/activity/create-by-robot-id';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
  this.activityBulkCreateByRobotId = function (robotId, listOfPhotoId, activityName, activityType, attUid, callback) {
    const body = {};
    body.robot_id = robotId;
    body.list_of_photo_id = listOfPhotoId;
    body.activity_name = activityName;
    body.activity_type = activityType;
    body.attUid = attUid;
    const methodPath = '/activity/bulk-create-by-robot-id';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  /*
   * key_type possible values
   *   - event_name_key (keyValue type string : eventName)
   *   - event_owner_api_key (keyValue type string : eventOwnerApiKey)
   *   - event_public_api_key (keyValue type string : eventPublicApiKey)
   *   - event_private_api_key (keyValue type string : eventPrivateApiKey)
   *   - attendee_uid (keyValue type string : attendeeUid)
   *   - attendee_and_org_uids (keyValue type json obj e.g. {"attendee_uid" : "value1", "organisation_uid" : "value2"})
   */
  this.photoListRetrieve = function (
    keyType,
    keyValue,
    eventId,
    isVisible,
    startDate,
    endDate,
    maxSize,
    pageNumber,
    minInterval,
    maxInterval,
    forKiosk,
    isCuratable,
    isCurated,
    isOriginal,
    printable,
    printed,
    attId,
    showTotalCount,
    fileName,
    getFromTmp,
    callback
  ) {
    const body = {};
    body.event_id = eventId;
    body.max_size = maxSize;
    body.page_number = pageNumber;
    body.min_time_minutes_interval = minInterval;
    body.max_time_minutes_interval = maxInterval;
    body.is_kiosk = forKiosk;
    body.is_curatable = isCuratable;
    body.is_curated = isCurated;
    body.is_original = isOriginal;
    body.printable = printable;
    body.printed = printed;
    body.file_name = fileName;
    body.attendee_uid = attId;
    body.show_total_count = showTotalCount;
    body.get_from_tmp = getFromTmp;
    if (typeof isVisible !== 'undefined' && isVisible !== null && isVisible !== '' && isVisible !== 'null') {
      body.is_visible = isVisible;
    }
    const hasApiKey = keyType == null;
    if (startDate) {
      body.start_date = startDate;
    }
    if (endDate) {
      body.end_date = endDate;
    }
    if (!hasApiKey) {
      body.key_type = keyType;
      body.key_value = keyValue;
    }

    const showApiErrors = keyType == 'event_owner_api_key';
    const methodPath = hasApiKey ? '/occo-owner/photo/list/retrieve' : '/photo/list/retrieve';
    _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  this.passCodeListRetrieve = function (callback) {
    const body = {};
    const methodPath = '/occo-owner/pass-code/list/retrieve';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.passCodeDelete = function (id, callback) {
    const body = {};
    body.id = id;
    const methodPath = '/occo-owner/pass-code/delete';
    const hasApiKey = true;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  // profile picture methods
  this.profilePhotoListRetrieve = function (attId, callback) {
    const body = {};
    body.attendee_uid = attId;
    const methodPath = '/attendee/profile-photo/list/retrieve';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
  this.profilePhotoTmpUploadAccessRetrieve = function (file_name, callback) {
    const body = {};
    body.file_relative_path = file_name;
    const methodPath = '/photo/tmp-upload-access/retrieve';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
  this.createProfilePhoto = function (attId, full_path, event_name, callback) {
    const body = {};
    body.attendee_uid = attId;
    body.full_path = full_path;
    body.event_name = event_name;
    const methodPath = '/attendee/profile-photo/create';
    const hasApiKey = false;
    _occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  function _occoApiPostRequest(hasApiKey, methodPath, body, callback) {
    _occoApiPostRequestBase(hasApiKey, methodPath, body, false, callback);
  }

  function _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback) {
    const showErr = hasApiKey || showApiErrors || window.DEBUG_MODE;
    const ajaxParams = {
      url: process.env.BACKEND_API + methodPath,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(body),

      success(resp, textStatus, jqXHR) {
        if (resp.status == 'ok') {
          callback(null, resp.result);
        } else if (resp.status == 'nok') {
          const err1 = {};
          err1.type = 'occo';
          err1.message_key = showErr ? resp.error_message_key : 'Internal Error';
          err1.message_text = showErr ? resp.error.message_text : 'Internal Error';
          err1.textStatus = textStatus;
          err1.jqXHR = jqXHR;
          err1.resp = resp;
          console.error('err', JSON.stringify(err1));
          callback(err1, null);
        } else {
          const err2 = {};
          err2.type = 'occo';
          err2.message_key = 'Internal Error';
          err2.jqXHR = jqXHR;
          err2.textStatus = textStatus;
          err2.resp = resp;
          console.error('err', JSON.stringify(err2));
          callback(err2, null);
        }
      },
      error(jqXHR, textStatus, errorThrown) {
        if (jqXHR.readyState == 0 || jqXHR.status == 0) {
          return; // it's not really an error,
          // it's accure when user refresh page before ajax call complition
        }
        const err = {};
        err.type = 'global';
        err.message_key = 'Internal Error';
        err.jqXHR = jqXHR;
        err.textStatus = textStatus;
        err.errorThrown = errorThrown;
        console.error('err', JSON.stringify(err));
        callback(err, null);
      },
    };
    if (hasApiKey) {
      cognitoApi.getApiKey((err, apiKey) => {
        if (err) {
          window.location.href = './';
          // callback(err, null);
          return;
        }
        ajaxParams.headers = {
          Authorization: apiKey,
        };
        $.ajax(ajaxParams);
      });
    } else {
      $.ajax(ajaxParams);
    }
  }
}
export const occoApi = new OccoApi();
